export const ZONES = [
  {
    id: "zone-1",
    num: "1",
    name: "Zone 1",
    region: "Northwest Metro",
    fee: "free",
    blurb: "Northwest metro home base — flat rates, no mileage fees, and our fastest response times outside Minneapolis proper.",
    cities: ["Brooklyn Park", "Brooklyn Center", "Robbinsdale", "Crystal", "New Hope", "Golden Valley", "Fridley", "Columbia Heights", "Blaine", "Coon Rapids", "Champlin", "Plymouth", "Maple Grove", "Osseo", "Anoka"],
    points: "255,115 420,105 520,145 510,285 455,310 425,395 300,385 200,360 180,240 200,150",
    label: [345, 262],
    labelSize: 110,
    dots: [
      { n: "Anoka", x: 375, y: 130 }, { n: "Champlin", x: 300, y: 155 }, { n: "Coon Rapids", x: 440, y: 140 },
      { n: "Blaine", x: 495, y: 175 }, { n: "Osseo", x: 285, y: 210 }, { n: "Maple Grove", x: 245, y: 240 },
      { n: "Fridley", x: 450, y: 215 }, { n: "Brooklyn Park", x: 340, y: 255 }, { n: "Columbia Heights", x: 475, y: 270 },
      { n: "Brooklyn Center", x: 395, y: 290 }, { n: "New Hope", x: 300, y: 315 }, { n: "Crystal", x: 335, y: 325 },
      { n: "Plymouth", x: 220, y: 345 }, { n: "Robbinsdale", x: 375, y: 350 }, { n: "Golden Valley", x: 390, y: 380 },
    ],
  },
  {
    id: "zone-2",
    num: "2",
    name: "Zone 2",
    region: "St. Paul / NE Metro",
    fee: "free",
    blurb: "St. Paul and the northeast inner ring — the same flat pricing as Minneapolis, never a mileage fee.",
    cities: ["Roseville", "St. Paul", "Falcon Heights", "Lauderdale", "Little Canada", "Maplewood", "Arden Hills", "Shoreview", "Vadnais Heights", "New Brighton", "North Oaks", "White Bear Lake"],
    points: "540,115 700,115 800,160 790,300 760,400 700,460 600,440 560,390 520,300 520,200",
    label: [655, 290],
    labelSize: 110,
    dots: [
      { n: "North Oaks", x: 610, y: 125 }, { n: "White Bear Lake", x: 740, y: 150 }, { n: "Shoreview", x: 600, y: 180 },
      { n: "Vadnais Heights", x: 665, y: 205 }, { n: "New Brighton", x: 550, y: 235 }, { n: "Arden Hills", x: 580, y: 255 },
      { n: "Little Canada", x: 670, y: 275 }, { n: "Roseville", x: 615, y: 300 }, { n: "Maplewood", x: 730, y: 335 },
      { n: "Falcon Heights", x: 600, y: 345 }, { n: "Lauderdale", x: 555, y: 370 }, { n: "St. Paul", x: 700, y: 440 },
    ],
  },
  {
    id: "zone-3",
    num: "3",
    name: "Zone 3",
    region: "Minneapolis",
    fee: "free",
    blurb: "Minneapolis proper — our home zone and fastest response. Most calls reached in under 30 minutes.",
    cities: ["North Minneapolis", "Northeast Minneapolis", "Downtown Minneapolis", "South Minneapolis", "Uptown / Central Minneapolis"],
    points: "400,310 480,295 555,315 560,390 525,470 470,505 405,490 380,400",
    label: [468, 422],
    labelSize: 64,
    dots: [
      { n: "North Mpls", x: 430, y: 340 }, { n: "Northeast", x: 520, y: 330 }, { n: "Downtown", x: 470, y: 405 },
      { n: "Uptown / Central", x: 425, y: 445 }, { n: "South Mpls", x: 465, y: 480 },
    ],
  },
  {
    id: "zone-4",
    num: "4",
    name: "Zone 4",
    region: "Far North Metro",
    fee: "fee",
    blurb: "Far north metro — $3 per mile beyond the first 15 miles, always confirmed before dispatch.",
    cities: ["Ham Lake", "Lino Lakes", "Circle Pines", "Lexington", "Forest Lake"],
    points: "415,15 790,15 805,100 560,105 415,100",
    label: [605, 74],
    labelSize: 80,
    dots: [
      { n: "Ham Lake", x: 445, y: 55 }, { n: "Lexington", x: 520, y: 60 }, { n: "Circle Pines", x: 505, y: 85 },
      { n: "Lino Lakes", x: 575, y: 55 }, { n: "Forest Lake", x: 745, y: 55 },
    ],
  },
  {
    id: "zone-5",
    num: "5",
    name: "Zone 5",
    region: "East Metro",
    fee: "fee",
    blurb: "East metro and the St. Croix side — $3 per mile beyond the first 15 miles, quoted upfront.",
    cities: ["Oakdale", "Woodbury", "Cottage Grove", "Stillwater", "Inver Grove Heights", "Eagan", "Mendota Heights"],
    points: "800,240 920,260 900,540 800,560 700,570 620,540 640,470 720,430 740,350 760,280",
    label: [778, 430],
    labelSize: 100,
    dots: [
      { n: "Stillwater", x: 880, y: 280 }, { n: "Oakdale", x: 795, y: 375 }, { n: "Woodbury", x: 845, y: 420 },
      { n: "Cottage Grove", x: 850, y: 510 }, { n: "Inver Grove Hts", x: 730, y: 520 }, { n: "Mendota Heights", x: 655, y: 500 },
      { n: "Eagan", x: 640, y: 545 },
    ],
  },
  {
    id: "zone-6",
    num: "6",
    name: "Zone 6",
    region: "South Metro",
    fee: "fee",
    blurb: "South metro — $3 per mile beyond the first 15 miles, confirmed upfront before we roll.",
    cities: ["Bloomington", "Richfield", "Edina", "Burnsville", "Apple Valley", "Rosemount"],
    points: "370,505 470,500 520,560 660,610 680,700 580,710 480,690 400,640 365,570",
    label: [518, 620],
    labelSize: 100,
    dots: [
      { n: "Edina", x: 395, y: 525 }, { n: "Richfield", x: 455, y: 520 }, { n: "Bloomington", x: 435, y: 575 },
      { n: "Burnsville", x: 505, y: 645 }, { n: "Apple Valley", x: 575, y: 655 }, { n: "Rosemount", x: 645, y: 685 },
    ],
  },
  {
    id: "zone-7",
    num: "7",
    name: "Zone 7",
    region: "Southwest Exurbs",
    fee: "quote",
    blurb: "Far southwest exurbs — outside standard pricing, so we quote an exact all-in price before booking. No surprises.",
    cities: ["Lakeville", "Prior Lake", "Shakopee", "Chaska", "Chanhassen", "& farther exurbs"],
    points: "150,530 280,540 340,610 500,675 520,745 300,745 170,700 140,610",
    label: [335, 665],
    labelSize: 90,
    dots: [
      { n: "Chanhassen", x: 215, y: 555 }, { n: "Chaska", x: 180, y: 615 }, { n: "Shakopee", x: 265, y: 655 },
      { n: "Prior Lake", x: 330, y: 695 }, { n: "Lakeville", x: 490, y: 725 },
    ],
  },
];

export const FEE_META = {
  free: { tag: "No mileage fee", fill: "rgba(255,90,0,0.10)", activeFill: "rgba(255,90,0,0.20)", stroke: "#FF5A00", dot: "#FF5A00", dash: undefined },
  fee: { tag: "+$3/mi after 15 mi", fill: "rgba(255,255,255,0.05)", activeFill: "rgba(255,255,255,0.10)", stroke: "rgba(255,255,255,0.45)", dot: "#D4D4D4", dash: "7 5" },
  quote: { tag: "Custom quote", fill: "rgba(255,255,255,0.02)", activeFill: "rgba(255,255,255,0.07)", stroke: "rgba(163,163,163,0.55)", dot: "#8A8A8A", dash: "2 5" },
};

export const ZONES_GEO = {
  "zone-1": {
    center: [45.1, -93.36],
    polygon: [
      [45.215, -93.4], [45.19, -93.225], [45.075, -93.245], [45.03, -93.25],
      [44.965, -93.33], [44.975, -93.47], [45.085, -93.49], [45.15, -93.44],
    ],
    cities: {
      "Brooklyn Park": [45.094, -93.356, "top"], "Brooklyn Center": [45.076, -93.313, "bottom"],
      "Robbinsdale": [45.032, -93.339, "bottom"], "Crystal": [45.033, -93.36, "left"],
      "New Hope": [45.038, -93.387, "left"], "Golden Valley": [44.991, -93.359, "bottom"],
      "Fridley": [45.086, -93.263], "Columbia Heights": [45.041, -93.263, "right"],
      "Blaine": [45.161, -93.235], "Coon Rapids": [45.173, -93.287, "top"],
      "Champlin": [45.189, -93.398, "left"], "Plymouth": [45.011, -93.455, "left"],
      "Maple Grove": [45.073, -93.456, "left"], "Osseo": [45.119, -93.402, "left"], "Anoka": [45.198, -93.387, "top"],
    },
  },
  "zone-2": {
    center: [45.03, -93.1],
    polygon: [
      [45.125, -93.2], [45.125, -93.06], [45.105, -92.98], [45.02, -92.975],
      [44.92, -93.02], [44.915, -93.13], [44.97, -93.2],
    ],
    cities: {
      "Roseville": [45.006, -93.157], "St. Paul": [44.954, -93.09],
      "Falcon Heights": [44.992, -93.176], "Lauderdale": [44.998, -93.206],
      "Little Canada": [45.027, -93.088], "Maplewood": [44.99, -93.025],
      "Arden Hills": [45.05, -93.157], "Shoreview": [45.079, -93.147],
      "Vadnais Heights": [45.058, -93.074], "New Brighton": [45.066, -93.202],
      "North Oaks": [45.103, -93.079], "White Bear Lake": [45.085, -93.01],
    },
  },
  "zone-3": {
    center: [44.968, -93.278],
    polygon: [
      [45.045, -93.31], [45.045, -93.255], [45.015, -93.215], [44.99, -93.21],
      [44.955, -93.215], [44.935, -93.23], [44.89, -93.28], [44.89, -93.33],
      [44.94, -93.34], [45.0, -93.33],
    ],
    cities: {
      "North Minneapolis": [45.03, -93.295, "left"], "Northeast Minneapolis": [45.01, -93.24],
      "Downtown Minneapolis": [44.977, -93.27, "top"], "South Minneapolis": [44.93, -93.27, "bottom"],
      "Uptown / Central Minneapolis": [44.948, -93.297, "left"],
    },
  },
  "zone-4": {
    center: [45.2, -93.15],
    polygon: [
      [45.3, -93.3], [45.3, -92.94], [45.23, -92.94], [45.13, -93.04],
      [45.125, -93.18], [45.18, -93.3],
    ],
    cities: {
      "Ham Lake": [45.25, -93.25], "Lino Lakes": [45.16, -93.088],
      "Circle Pines": [45.149, -93.151], "Lexington": [45.142, -93.163],
      "Forest Lake": [45.278, -92.985],
    },
  },
  "zone-5": {
    center: [44.92, -93.0],
    polygon: [
      [45.075, -92.96], [45.075, -92.76], [45.0, -92.76], [44.79, -92.9],
      [44.77, -93.06], [44.8, -93.2], [44.9, -93.19], [44.945, -93.0],
    ],
    cities: {
      "Oakdale": [44.963, -92.965], "Woodbury": [44.924, -92.959],
      "Cottage Grove": [44.828, -92.944], "Stillwater": [45.056, -92.806],
      "Inver Grove Heights": [44.848, -93.043], "Mendota Heights": [44.884, -93.158],
      "Eagan": [44.804, -93.167],
    },
  },
  "zone-6": {
    center: [44.81, -93.26],
    polygon: [
      [44.905, -93.38], [44.905, -93.26], [44.855, -93.25], [44.79, -93.1],
      [44.71, -93.1], [44.71, -93.3], [44.8, -93.38],
    ],
    cities: {
      "Bloomington": [44.841, -93.298], "Richfield": [44.883, -93.283],
      "Edina": [44.89, -93.35], "Burnsville": [44.768, -93.278],
      "Apple Valley": [44.732, -93.218], "Rosemount": [44.739, -93.126],
    },
  },
  "zone-7": {
    center: [44.76, -93.44],
    polygon: [
      [44.89, -93.58], [44.89, -93.48], [44.78, -93.38], [44.7, -93.18],
      [44.61, -93.18], [44.61, -93.3], [44.68, -93.47], [44.74, -93.65],
    ],
    cities: {
      "Lakeville": [44.65, -93.243], "Prior Lake": [44.713, -93.423],
      "Shakopee": [44.798, -93.527], "Chaska": [44.789, -93.602],
      "Chanhassen": [44.862, -93.531],
    },
  },
};
